var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('form-component',{attrs:{"page-data":_vm.form},on:{"updateSeoPage":_vm.updateSeoPage,"fetchData":_vm.fetchData,"fetchByLocale":_vm.fetchByLocale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }